import {
    Alert,
    Button,
    FormItem,
    GridInformation,
    Typogaphy,
} from 'vnetwork-ui'
import { BusinessExplaination } from '../../../types/response'
import { Link } from 'react-router-dom'
import { generatePathDatacentral, paths } from '@/utils/path'
import { updateBusinessExplaination } from '../../../services'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useForm } from 'react-hook-form'
import { BusinessExplainationPayload } from '../../../types/payload'
import FollowupExplaination from './FollowupExplaination'
import ClosedExplaination from './ClosedExplaination'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { useTranslation } from 'react-i18next'
import { updateBussinessSchema } from '../schema'
import { yupResolver } from '@hookform/resolvers/yup'
import { REASON_UNPOTENTIAL } from '@/modules/Business/types/utils'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
interface BusinessInfoProps {
    business?: BusinessExplaination
    disable?: boolean
}
const BusinessInfo: React.FC<BusinessInfoProps> = ({ business, disable }) => {
    const { t } = useTranslation()
    const { refetchCurrent } = useDataGridRefetch({
        reactQueryKey: 'business-detail',
    })
    const { mutateAsync: updateBusinessExplainationMutation, isPending } =
        useMutationWithHandler(
            {
                mutationFn: updateBusinessExplaination,
            },
            {
                reactQueryKeys: QUERY_KEYS.BUSINESS,
                successMessage: t('updated-success'),
                onSuccess: () => {
                    refetchCurrent()
                },
            }
        )
    const {
        control,
        handleSubmit,
        watch,
        formState: { isDirty },
        reset,
    } = useForm<BusinessExplainationPayload>({
        defaultValues: {
            budget_explaination:
                business?.explaination.budget_explaination || 0,
            provider_explaination:
                business?.explaination.provider_explaination || '',
            influencer_explaination:
                business?.explaination.influencer_explaination || '',
            problem_explaination:
                business?.explaination.problem_explaination || '',
            explaination_result:
                business?.explaination.explaination_result || 'followup',
            expected_date: business?.explaination.expected_date || null,
            failed_reason:
                business?.explaination.failed_reason ||
                REASON_UNPOTENTIAL(t)[0]?.value ||
                '',
            failed_explanation: business?.explaination.failed_explanation || '',
            success_reason: business?.explaination.success_reason || '',
            success_explanation:
                business?.explaination.success_explanation || '',
            success_improvement:
                business?.explaination.success_improvement || '',
            failed_improvement: business?.explaination.failed_improvement || '',
        },
        // @ts-ignore
        resolver: yupResolver(updateBussinessSchema(t) as any),
    })
    const explainationResult = watch('explaination_result')
    const onSubmit = async (data: BusinessExplainationPayload) => {
        if (!business?.business.business_id) return
        const dataToSubmit = {
            ...data,
            business_id: business.business.business_id,
        }
        try {
            await updateBusinessExplainationMutation(dataToSubmit)
            reset(data)
        } catch (error) {
            console.error('Error submitting form', error)
        }
    }
    return (
        <div className="p-4">
            <Typogaphy className="font-medium" size="small">
                {t('business-infomation')}
            </Typogaphy>
            <GridInformation
                data={[
                    {
                        label: t('business-infomation-name'),
                        value: business?.business.metadata.customer
                            .customer_id ? (
                            <Link
                                to={generatePathDatacentral(
                                    paths.customerDetail,
                                    {
                                        id: business?.business.metadata.customer
                                            .customer_id,
                                    }
                                )}
                                style={{
                                    textDecoration: 'underline',
                                    color: 'blue',
                                }}
                            >
                                {
                                    business?.business.metadata.customer
                                        .customer_name
                                }
                            </Link>
                        ) : (
                            business?.business.metadata.customer.customer_name
                        ),
                    },
                    {
                        label: t('business-infomation-address'),
                        value: business?.business.business_place || '',
                    },
                    {
                        label: t('business-infomation-phone-number'),
                        value: business?.business.metadata?.customer
                            ?.customer_phone,
                    },
                    {
                        label: t('uiPosition'),
                        value: business?.business.metadata?.customer
                            ?.customer_position,
                    },
                ]}
                head={{
                    title: '',
                }}
            />
            <Alert variant="warning" className="border rounded-[8px] mt-2">
                <span className="text-orange-300 font-medium">
                    {t('business-infomation-warning')}
                </span>{' '}
            </Alert>
            <div className="border rounded-[8px] p-4 bg-white mt-2">
                <Typogaphy className="font-medium" size="small">
                    {t('business-result')}
                </Typogaphy>
                <FormItem
                    control={control}
                    direction="row"
                    type="radiogroup"
                    name="explaination_result"
                    disabled={disable}
                    options={[
                        {
                            label: t('business-result-followup'),
                            value: 'followup',
                        },
                        {
                            label: t('business-result-closed'),
                            value: 'closed',
                        },
                    ]}
                />
                {explainationResult === 'followup' && (
                    <FollowupExplaination control={control} disable={disable} />
                )}

                {explainationResult === 'closed' && (
                    <ClosedExplaination control={control} disable={disable} />
                )}

                <div className="flex justify-end mt-4">
                    <Button
                        size="small"
                        disabled={isPending || disable || !isDirty}
                        loading={isPending}
                        onClick={handleSubmit(onSubmit)}
                    >
                        {t('business-result-submit')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
export default BusinessInfo
